import Close16 from '@carbon/icons-react/es/close/16';
import { Tooltip, Typography } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Avatar } from 'components/atoms/avatar';
import { Button } from 'components/atoms/button';
import { ProductiveHeading07 } from 'components/styles';
import { UserOption } from 'utils/project-fields/types';

const PartnerName = styled.div`
  ${ProductiveHeading07};
`;
const PartnerNameWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-04);
`;
const RemoveButton = styled(Button)`
  min-width: 0px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  transition: visibility 0s;
`;
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: var(--spacing-04) var(--spacing-03);
  justify-content: space-between;
  ${RemoveButton} {
    visibility: hidden;
  }
  &:hover {
    background-color: var(--coolest-gray-10);
    ${RemoveButton} {
      visibility: visible;
    }
  }
`;

export const Partners = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 calc(var(--spacing-03) * -1);
  ${Wrapper}:not(:last-child) {
    border-bottom: 1px solid var(--border-color);
  }
`;

interface Props {
  partnerOption: UserOption;
  onRemove: (partner: UserOption) => void;
  className?: string;
}

export const PartnerRow: FC<Props> = ({
  partnerOption,
  onRemove,
  className,
}) => {
  return (
    <Wrapper className={className}>
      <PartnerNameWrapper>
        <Avatar
          key={partnerOption.value}
          src={partnerOption.imageUrl}
          name={partnerOption.label}
        />
        <PartnerName>
          <Typography.Text
            style={{ width: '100%' }}
            ellipsis={{ tooltip: true }}
          >
            {partnerOption.label}
          </Typography.Text>
        </PartnerName>
      </PartnerNameWrapper>
      <Tooltip title={<FormattedMessage id="remove" />}>
        <RemoveButton
          icon={<Close16 />}
          type="text"
          size="small"
          onClick={() => onRemove(partnerOption)}
        />
      </Tooltip>
    </Wrapper>
  );
};
